import { RiErrorWarningFill } from "react-icons/ri";
import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Col, Row, Container, Form, Image } from 'react-bootstrap'
import toast from 'react-hot-toast';
import { APIurls, IMAGES, Axios } from '../../constants';
import { reviewSchema } from '../../schemas';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import notFound from './../../assets/imgs/not.svg'

const Review = () => {
    const navigate = useNavigate();

    const { clientId, projectId } = useParams();

    const [loading, setLoading] = useState(false)
    const [Err, setErr] = useState([]);
    const [url, setUlr] = useState(false);



    const onSubmit = async (values, actions) => {
        setLoading(true)
        try {
            const res = await Axios.post(APIurls.postReview, values);
            setLoading(false)
            if (res && res?.data?.statusCode === 200) {
                actions?.resetForm()
                navigate('/');
            } else {
                toast.error('error in query...');
                actions?.resetForm()
            }

        } catch (error) {
            setErr(error?.response?.errors);
            console.log("error", error)
        } finally {
            setLoading(false);
        }
    }



    const { values, errors, touched, handleChange, handleSubmit } = useFormik({
        initialValues: { overall_satisfaction: '', communication: '', quality_work: '', timeliness: '', value_for_money: '', recommendation: '', work_with_us: '', should_improved: '', additional_comments: '', client_id: clientId, project_id: projectId },
        validationSchema: reviewSchema,
        onSubmit,
    })

    useEffect(() => {
        window.scroll(0, 0);
        handleUrlVerification();
    }, [clientId]);



    const handleUrlVerification = async () => {
        try {
            const res = await axios.get(APIurls?.baseUrl + APIurls.urlVerification + '/' + clientId + '/' + projectId)
            if (res && res?.data?.success) {
                setUlr(res?.data?.success)
                toast.success(res?.data?.message)
            } else {
                setUlr(res?.data?.success)
                toast.error(res?.data?.message)
            }
        } catch (error) {
            console.log("error", error)
        } finally {
            setLoading(false);
        }
    }

    const data = [
        { icon: '😩', text: 'Highly Unsatisfied' },
        { icon: '🙁', text: 'Unsatisfied' },
        { icon: '😐', text: 'Neutral' },
        { icon: '🙂', text: 'Satisfied' },
        { icon: '😄', text: 'Highly Satisfied' },
    ];
    const data2 = [
        { icon: '😩', text: 'Very Poor' },
        { icon: '🙁', text: 'Poor' },
        { icon: '😐', text: 'Average' },
        { icon: '🙂', text: 'Good' },
        { icon: '😄', text: 'Excellent' },
    ];
    const data3 = [
        { icon: '👍', text: 'Yes' },
        { icon: '👎', text: 'No' },
    ];

    return (
        <>
            {
                loading ? <Loader /> :
                    <Container>

                        <div className='reviewSection'>
                            {url ?
                                <>
                                    <Row>
                                        <Col xs={12} sm={12} md={10} lg={8} className='mx-auto'>
                                            <h1 data-aos="fade-down">Tell us about your experience with us</h1>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Form onSubmit={handleSubmit} method='post'>
                                                <Row>
                                                    <Col xs={12} md={12} lg={10} xl={6}>
                                                        <div className='reviewItem'>
                                                            <h4>Overall Satisfaction</h4>
                                                            <p>How satisfied are you with the overall outcome of the project?</p>
                                                            <ul className="emoges">
                                                                {data?.map((item, i) => (
                                                                    <li key={i}>
                                                                        <input type="radio" id={item?.text + '1'} value={item?.text} name="overall_satisfaction" onChange={handleChange} />
                                                                        <label htmlFor={item?.text + '1'}>
                                                                            <h3>{item?.icon}</h3>
                                                                            <p> {item?.text}</p>
                                                                        </label>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            {errors?.overall_satisfaction || touched.overall_satisfaction ? <span className='text-danger'>{errors?.overall_satisfaction}</span> : ''}
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={12} lg={10} xl={6}>
                                                        <div className='reviewItem borderRight'>
                                                            <h4>Communication</h4>
                                                            <p>How would you rate the communication throughout the project?</p>
                                                            <ul className="emoges">
                                                                {data2?.map((item, i) => (
                                                                    <li key={i}>
                                                                        <input type="radio" id={item?.text + '2'} value={item?.text} onChange={handleChange} name="communication" />
                                                                        <label htmlFor={item?.text + '2'}>
                                                                            <h3>{item?.icon}</h3>
                                                                            <p> {item?.text}</p>
                                                                        </label>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            {errors?.communication || touched.communication ? <span className='text-danger'>{errors?.communication}</span> : ''}
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={12} lg={10} xl={6}>
                                                        <div className='reviewItem'>
                                                            <h4>Quality of Work</h4>
                                                            <p>How would you rate the quality of the work delivered?</p>
                                                            <ul className="emoges">
                                                                {data2?.map((item, i) => (
                                                                    <li key={i}>
                                                                        <input type="radio" id={item?.text + '3'} value={item?.text} onChange={handleChange} name="quality_work" />
                                                                        <label htmlFor={item?.text + '3'}>
                                                                            <h3>{item?.icon}</h3>
                                                                            <p> {item?.text}</p>
                                                                        </label>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            {errors?.quality_work || touched.quality_work ? <span className='text-danger'>{errors?.quality_work}</span> : ''}

                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={12} lg={10} xl={6}>
                                                        <div className='reviewItem borderRight'>
                                                            <h4>Timeliness</h4>
                                                            <p>Was the project completed within the agreed-upon timeline?</p>
                                                            <ul className="emoges">
                                                                {data3?.map((item, i) => (
                                                                    <li key={i}>
                                                                        <input type="radio" id={item?.text + '4'} value={item?.text} onChange={handleChange} name="timeliness" />
                                                                        <label htmlFor={item?.text + '4'}>
                                                                            <h3>{item?.icon}</h3>
                                                                            <p> {item?.text}</p>
                                                                        </label>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            {errors?.timeliness || touched.timeliness ? <span className='text-danger'>{errors?.timeliness}</span> : ''}

                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={12} lg={10} xl={6}>
                                                        <div className='reviewItem'>
                                                            <h4>Value for Money</h4>
                                                            <p>How would you rate the value for money for the services provided?</p>
                                                            <ul className="emoges">
                                                                {data2?.map((item, i) => (
                                                                    <li key={i}>
                                                                        <input type="radio" id={item?.text + '5'} value={item?.text} onChange={handleChange} name="value_for_money" />
                                                                        <label htmlFor={item?.text + '5'}>
                                                                            <h3>{item?.icon}</h3>
                                                                            <p> {item?.text}</p>
                                                                        </label>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            {errors?.value_for_money || touched.value_for_money ? <span className='text-danger'>{errors?.value_for_money}</span> : ''}

                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={12} lg={10} xl={6}>
                                                        <div className='reviewItem borderRight'>
                                                            <h4>Would You Recommend Us to Others?</h4>
                                                            <ul className="emoges">
                                                                {data3?.map((item, i) => (
                                                                    <li key={i}>
                                                                        <input type="radio" id={item?.text + '6'} value={item?.text} onChange={handleChange} name="recommendation" />
                                                                        <label htmlFor={item?.text + '6'}>
                                                                            <h3>{item?.icon}</h3>
                                                                            <p> {item?.text}</p>
                                                                        </label>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            {errors?.recommendation || touched.recommendation ? <span className='text-danger'>{errors?.recommendation}</span> : ''}

                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={12} lg={10} xl={6}>
                                                        <Form.Group className="mb-4" >
                                                            <Form.Control as="textarea" name="work_with_us" rows={8} id={"work_with_us"} value={values?.work_with_us} onChange={handleChange} placeholder='What Did You Like Most About Working With Us?' />
                                                            {errors?.work_with_us || touched.work_with_us ? <span className='text-danger'>{errors?.work_with_us}</span> : ''}

                                                        </Form.Group>

                                                    </Col>
                                                    <Col xs={12} md={12} lg={10} xl={6}>
                                                        <Form.Group className="mb-4" >
                                                            <Form.Control as="textarea" name='should_improved' rows={8} id={"should_improved"} value={values?.should_improved} onChange={handleChange} placeholder='What Could Be Improved?' />
                                                            {errors?.should_improved || touched.should_improved ? <span className='text-danger'>{errors?.should_improved}</span> : ''}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} md={12} lg={12} xl={12} className='mx-auto'>
                                                        <Form.Group className="mb-4" >
                                                            <Form.Control as="textarea" rows={8} name='additional_comments' id={"additional_comments"} value={values?.additional_comments} onChange={handleChange} placeholder='Additional Comments or Suggestions' />
                                                        </Form.Group>
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col xs={12} md={12} lg={10} xl={3} className='mx-auto'>
                                                        <button className='getInto w-100' type='submit'>Submit</button>
                                                    </Col>
                                                </Row>

                                            </Form>

                                        </Col>
                                    </Row>
                                </>
                                :
                                <Row>
                                    <Col xs={12} sm={10} md={8} lg={6} xl={6} className='mx-auto text-center'>
                                        <div className="warningDiv">
                                            <RiErrorWarningFill size={95} color="#fff" />
                                            <h4>Oops! Invalid URL</h4>
                                            <p>It seems like the link you clicked on is either broken or no longer exists. Please check the URL for any errors or try visiting our home page for more information.</p>
                                            <Link to="/" className="btn getInto">Home</Link>
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </Container>
            }
        </>

    )
}

export default Review